import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import React, {Fragment} from 'react';
import {LinkProps as NavLinkProps, useLocation} from 'react-router-dom';
import {ProductLogo} from 'presentation/components/ProductLogo';
import Icon from 'presentation/icons';
import {useMenuList} from '../useMenuList';
import {MenuListType} from '../types';
import {StyledDrawer, StyledToolbar} from '../Sidebar/styles';
import {
	ActiveBorder,
	StyledItemWrapper,
	StyledListItemIcon,
	StyledModalButton,
	StyledNavLink,
} from './styles';
import {translations} from 'presentation/translations-new';

import {useNetworkProviderItems} from 'presentation/pages/private/home/components/OptionsDrawer/hooks/useNetworkProviderItems';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';

const {network} = translations['pt-br'].others.sidebar;
const {serviceNetwork} = translations['pt-br'].privateFlow.services;

export function NotredameSidebar() {
	const {pathname} = useLocation();
	const {MENU_LIST} = useMenuList();

	const {openOptionsDrawer} = useOpenOptionsDrawerStore();
	const {items: networkProviderItems} = useNetworkProviderItems();

	const Link = React.forwardRef<HTMLAnchorElement, NavLinkProps>((itemProps, ref) => (
		<StyledNavLink ref={ref} {...itemProps} />
	));

	const ModalLink = React.forwardRef<HTMLDivElement>((itemProps, ref) => (
		<StyledModalButton ref={ref} open {...itemProps} />
	));

	const handleModalActionLink = (item: MenuListType) => {
		if (item.title === network) {
			openOptionsDrawer(serviceNetwork, networkProviderItems);
		}
	};

	function isActiveRoute(route?: string) {
		if (!route) return false;

		const bestMatch = MENU_LIST.filter(
			menuItem => pathname === menuItem.route || pathname.startsWith(`${menuItem.route}/`),
		).reduce<MenuListType | null>(
			(best, current) =>
				!best || (current?.route?.length ?? 0) > (best?.route?.length ?? 0)
					? current
					: best,
			null,
		);

		return bestMatch?.route === route;
	}

	return (
		<Fragment>
			<StyledDrawer variant="permanent" open>
				<StyledToolbar open>
					<Stack height={80} direction="row" alignItems="center">
						<ProductLogo customHeight={32} />
					</Stack>
				</StyledToolbar>
				{MENU_LIST.map((item: MenuListType) => {
					const isFunctionAction = item?.title === network;
					const isActive = isActiveRoute(item.route);
					return (
						<StyledItemWrapper key={item.route ?? item.title}>
							<ActiveBorder $isActive={isActive} />
							<ListItemButton
								component={isFunctionAction ? ModalLink : Link}
								to={isFunctionAction ? undefined : item?.route}
								className={!isFunctionAction && isActive ? 'active' : undefined}
								data-tag-id={item.dataTagId}
								data-testid={item.dataTestId}
								disableRipple
								onClick={
									isFunctionAction ? () => handleModalActionLink(item) : undefined
								}
								id={item?.id}>
								<StyledListItemIcon open>
									<Icon name={item.icon} />
								</StyledListItemIcon>
								<ListItemText secondary={item.title} sx={{margin: 0}} />
							</ListItemButton>
						</StyledItemWrapper>
					);
				})}
			</StyledDrawer>
		</Fragment>
	);
}
